var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfDoneCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 39.2,
    height: 39.2,
    viewBox: "0 0 39.2 39.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause (1) 1",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6 39.2C8.79259 39.2 0 30.4074 0 19.6C0 8.79259 8.79259 0 19.6 0C30.4074 0 39.2 8.79259 39.2 19.6C39.2 30.4074 30.4074 39.2 19.6 39.2Z",
    fill: "#72B33E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.6218 20.2565C34.2612 20.2565 33.9685 19.9638 33.9685 19.6032C33.9698 15.5669 32.1934 11.7978 28.9666 8.98915C28.6942 8.75265 28.6661 8.33975 28.9026 8.06795C29.1391 7.79615 29.552 7.76744 29.8245 8.00394C33.3407 11.0641 35.2766 15.1834 35.2753 19.6032C35.2751 19.9645 34.9824 20.2565 34.6218 20.2565Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.8024 6.15689C24.7273 6.15689 24.6508 6.1438 24.5763 6.11639C22.9823 5.5277 21.3051 5.2291 19.5908 5.22849C19.2302 5.22849 18.9375 4.93579 18.9375 4.57518C18.9375 4.21388 19.2302 3.92188 19.5908 3.92188C21.46 3.92256 23.29 4.24857 25.0285 4.89008C25.3669 5.01488 25.5401 5.39119 25.4153 5.72959C25.3179 5.9935 25.0677 6.15689 24.8024 6.15689Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.79406 31.3586C9.64576 31.3586 9.49746 31.3089 9.37465 31.2064C5.80087 28.2141 3.91276 24.2 3.91406 19.5986C3.91406 19.2373 4.20676 18.9453 4.56737 18.9453C4.92798 18.9453 5.22068 19.238 5.22068 19.5986C5.21938 23.8015 6.94617 27.4687 10.2135 30.2042C10.4899 30.4355 10.5264 30.8477 10.2952 31.1241C10.1658 31.2789 9.98026 31.3586 9.79406 31.3586Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.5928 35.2801C17.8334 35.2801 16.1047 34.9907 14.455 34.4197C14.114 34.3014 13.9336 33.929 14.0519 33.5887C14.1695 33.2477 14.5412 33.066 14.8829 33.1849C16.3947 33.7082 17.979 33.9735 19.5928 33.9735C19.9534 33.9735 20.2461 34.2655 20.2461 34.6268C20.2461 34.9881 19.9534 35.2801 19.5928 35.2801Z",
    fill: "#61A333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.5938 19.6016L17.5938 23.6016L25.5938 15.6016",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.2,
    height: 39.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfDoneCheck);
export default __webpack_public_path__ + "static/media/cf-done-check.5c23b61c2850b54cf91a01c73441fdd2.svg";
export { ForwardRef as ReactComponent };